import { render, staticRenderFns } from "./schoolinfo-banner.vue?vue&type=template&id=585ccc18&scoped=true"
import script from "./schoolinfo-banner.vue?vue&type=script&lang=js"
export * from "./schoolinfo-banner.vue?vue&type=script&lang=js"
import style0 from "./schoolinfo-banner.vue?vue&type=style&index=0&id=585ccc18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585ccc18",
  null
  
)

export default component.exports